import { render, staticRenderFns } from "./SignUpRequired.vue?vue&type=template&id=03c000c1&scoped=true&"
import script from "./SignUpRequired.vue?vue&type=script&lang=js&"
export * from "./SignUpRequired.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c000c1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/Ron/Projects/rentalawareclient/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
installComponents(component, {VBtn})
